module.exports = __webpack_public_path__ + "static/media/file-csv.f59cbd5a.svg";